// extracted by mini-css-extract-plugin
export var sliderRange = "_r3-2";
export var sliderRoot = "_r3-0";
export var sliderThumb = "_r3-3";
export var sliderTrack = "_r3-1";